// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__20Yo_","preLoader":"Loader_preLoader__1Aq-_","loader":"Loader_loader__SYCQT"};